import { render, staticRenderFns } from "./project-common.vue?vue&type=template&id=62c70922&"
import script from "./project-common.vue?vue&type=script&lang=js&"
export * from "./project-common.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports